import React from "react";
import { Handle, Position } from "reactflow";

import CustomNode from "./CustomNode";

import { getHandles } from "../../../util/handeUtils";
import { getBalanceString } from "../../../util/stringUtils";

import "./Profile.scss";

const Profile = ({ data }) => {
  const balances = Object.entries(data.balances);

  return (
    <CustomNode color="#b3da77">
      <Handle type="target" position={Position.Top} isConnectable={false} />
      <div className="sourceHandlesContainer">
        {getHandles(data.nodeId, data.numberOfChildren)}
      </div>

      <div className="nodrag">
        <div className="profile">
          <p className="name">{data.fullName}</p>
          <div className="balancesContainer">
            {balances.map((balanceArray) => {
              // const [currency, balance] = balanceArray;
              const [currency, balance] = balanceArray;
              return (
                <div key={currency} className="balanceContainer">
                  <span className="balanceLabel">
                    Balance {`(${currency})`}:
                  </span>
                  <span className="balanceValue">
                    {getBalanceString(balance, currency)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </CustomNode>
  );
};

export default Profile;
